import React, { Component } from 'react';
import { Button, Form, Grid, Icon, Accordion } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import {
  InputField,
  SelectField,
  DatePickerField,
} from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { FilterEnum, AdjustmentEnum } from 'Common/FieldEnum';
import { GenericFiltersContainer } from 'Components/filters/container';
import { DatePickerCustomButton } from 'Components';
import { SiteComponent } from 'Common/SiteComponent';

import { AdjustmentInfo } from './../../containers/createEditAdjustment/AdjustmentInfo';

class CreateEditAdjustmentComponent extends Component {
  static propTypes = {
    assignItemsBidGroupData: PropTypes.array.isRequired,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    filterValues: PropTypes.object.isRequired,
    adjustmentItemsData: PropTypes.array.isRequired,
    onChangeOfAdjustmentDT: PropTypes.func,
    onChangeOfSite: PropTypes.func,
    handleChange: PropTypes.func,
    clearFilters: PropTypes.func,
    fetchingAdjustmentItems: PropTypes.bool,
    fetchingAdjustmentDetail: PropTypes.bool,
    isDisabled: PropTypes.bool,
    resetPageOnDataChange: PropTypes.bool,
    onResetPageOnDataChange: PropTypes.func,
  };
  static defaultProps = {
    onChangeOfAdjustmentDT: () => {},
    onChangeOfSite: () => {},
    handleChange: () => {},
    clearFilters: () => {},
    resetPageOnDataChange: false,
    onResetPageOnDataChange: () => {},
    fetchAdjustmentItems: false,
    fetchingAdjustmentDetail: false,
    isDisabled: false,
  };
  state = {
    activeIndex: 0,
  };
  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({
      activeIndex: newIndex,
    });
  };

  render() {
    const {
      assignItemsBidGroupData,
      assignItemsItemGroupData,
      filterValues,
      adjustmentItemsData,
      onChangeOfAdjustmentDT,
      onChangeOfSite,
      handleChange,
      clearFilters,
      fetchingAdjustmentItems,
      fetchingAdjustmentDetail,
      isDisabled,
      onResetPageOnDataChange,
      resetPageOnDataChange,
    } = this.props;

    const fields = [
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: assignItemsItemGroupData,
        label: 'ITEM GROUP',
      },
      {
        name: FilterEnum.GroupId_Bid,
        component: SelectField,
        type: 'text',
        options: assignItemsBidGroupData,
        label: 'BID GROUP',
        maxLength: 20,
      },
    ];
    return (
      <Form>
        <Grid>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Field
                component={DatePickerField}
                label={'Adjustment Date'}
                dateFormat={DATE_FORMAT_FOR_UI}
                name={AdjustmentEnum.TransactionDT}
                type={'text'}
                dropdownMode="select"
                onChange={onChangeOfAdjustmentDT}
                customInput={<DatePickerCustomButton isDisabled={isDisabled} />}
              />
            </Grid.Column>
            <Grid.Column>
              <SiteComponent
                name={AdjustmentEnum.Site}
                isForm={true}
                label={'Site'}
                isAllRequired={false}
                showAllActiveSites={true}
                onChange={(newVal, preVal, field) =>
                  onChangeOfSite(null, newVal, preVal, field)
                }
                disabled={isDisabled}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name={AdjustmentEnum.Comments}
                component={InputField}
                type="text"
                maxLength={50}
                label={'Comments'}
                disabled={isDisabled}
              />
            </Grid.Column>
            <Grid.Column />
          </Grid.Row>
        </Grid>
        <Accordion fluid styled>
          <Accordion.Title
            active={!this.state.activeIndex}
            index={0}
            onClick={this.handleClick}
          >
            <Icon name="dropdown" />
            <span className={'text-orange'}>Filter By</span>
          </Accordion.Title>
          <Accordion.Content active={!this.state.activeIndex}>
            <Grid className={'remove-spacing'}>
              <GenericFiltersContainer
                fields={fields}
                onChange={handleChange}
                filterValues={filterValues}
              />
              <Grid.Row>
                <Grid.Column>
                  <Button
                    className={'clear-filters-button'}
                    content="Clear Filters"
                    onClick={clearFilters}
                    type={'button'}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Field
                component={AdjustmentInfo}
                name={AdjustmentEnum.AdjustmentItemsInfo}
                {...{
                  dataSource: adjustmentItemsData,
                  fetchingAdjustmentItems,
                  fetchingAdjustmentDetail,
                  onResetPageOnDataChange: onResetPageOnDataChange,
                  resetPageOnDataChange: resetPageOnDataChange,
                }}
                disabled={isDisabled}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

export default CreateEditAdjustmentComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/components/createEditAdjustment/CreateEditAdjustmentComponent.js